import { useBaseStore } from '@common/stores/storage';

// 原生APP爬虫交互对象
const nativeCrawlerMethods = {
  /**
   * 唤起原生APP与爬虫交互
   * @param {string} step  提交步骤：10-申请 20-提现 30-消费 40-个人中心
   * @param {string} perm  获取通讯录权限： contact-通讯录 sms-短信 calllog-通话记录
   * @param {number} phoneNum 修改后的手机号
   * @return Void
   */
  step: {
    applying: '10',
    cash: '20',
    pay: '30',
    center: '40',
  },
  perm: {
    contact: 'contact',
    sms: 'sms',
    calllog: 'calllog',
  },
  // 返回APP
  backtoApp: function () {
    if (window.appNative?.backtoApp) {
      window.appNative.backtoApp();
    } else {
      window.postMessage(JSON.stringify({ id: '0', command: 'backToApp', params: {} }), '*');
    }
  },
  // 调用标识： 顺逸花APP调用
  flag: function () {
    const { appKey } = useBaseStore();
    return ['SYH_IOS', 'SYH_ANDROID', 'AYH_HARMONY', 'AYH_LITE_IOS'].includes(appKey);
  },
  flagyyh: function () {
    const { appKey } = useBaseStore();
    return ['newzy_IOS', 'newzy_ANDROID', 'newzy_LITE_IOS'].includes(appKey);
  },
  flagKmr: function () {
    const { appKey } = useBaseStore();
    return ['MS_IOS_KMR', 'MS_ANDROID_KMR'].includes(appKey);
  },
  flagmsjr: function () {
    const { appKey } = useBaseStore();
    return ['MS_IOS', 'MS_ANDROID', 'MS_HARMONY'].includes(appKey);
  },
  flagmsfq: function () {
    const { appKey } = useBaseStore();
    return ['MS_LITE_ANDROID', 'MS_LITE_IOS'].includes(appKey);
  },
  //提交申请
  submitApply: function () {
    window.appNative.submitApply();
  },
  //设置交易密码
  configurePayPwd: function (step) {
    // appNative.configuretPayPwd(String step);
    window.appNative.configuretPayPwd(step);
  },
  //修改交易密码
  modifyPayPwd: function (step) {
    // appNative.modifyPayPwd(String step);
    window.appNative.modifyPayPwd(step);
  },
  //修改登录密码
  modifyPwd: function (step) {
    // appNative.modifyPwd(String step);
    window.appNative.modifyPwd(step);
  },
  //修改注册手机号
  modifyPhone: function (step, phoneNum) {
    // appNative.modifyPhone(String step, String phoneNum);
    window.appNative?.modifyPhone(step, phoneNum);
  },
  //修改银行卡
  modifyBankcard: function (step) {
    window.appNative?.modifyBankcard(step);
  },
  //提现
  pay: function (step) {
    // appNative.pay(String step);
    window.appNative?.pay(step);
  },
  callFingerPay: function () {
    window.appNative?.callFingerPay && window.appNative?.callFingerPay();
  },
  // 获取通讯录权限
  requestPermission: function (perm) {
    // appNative.requestPermission(String perm);
    window.appNative?.requestPermission(perm);
  },
  //提交申请(新)
  submitApplyNew: function (data) {
    window.appNative?.submitApplyNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'submitApplyNew', params: data }));
    }
  },
  //设置交易密码
  configurePayPwdNew: function (data) {
    // appNative.configurePayPwdNew(String data);
    window.appNative?.configurePayPwdNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'configurePayPwdNew', params: data }));
    }
  },
  //修改交易密码
  modifyPayPwdNew: function (data) {
    // appNative.modifyPayPwdNew(String data);
    window.appNative?.modifyPayPwdNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'modifyPayPwdNew', params: data }));
    }
  },
  //修改注册手机号
  modifyPhoneNew: function (data) {
    // appNative.modifyPhoneNew(String data);
    window.appNative?.modifyPhoneNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'modifyPhoneNew', params: data }));
    }
  },
  //修改银行卡
  modifyBankcardNew: function (data) {
    // appNative.modifyBankcardNew(String data);
    window.appNative?.modifyBankcardNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'modifyBankcardNew', params: data }));
    }
  },
  //确认合同
  confirmContractNew: function (data) {
    // appNative.confirmContractNew(String data);
    window.appNative?.confirmContractNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'confirmContractNew', params: data }));
    }
  },
  //自有还款
  ayhRepayNew: function (data) {
    // appNative.ayhRepayNew(String data);
    window.appNative?.ayhRepayNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'ayhRepayNew', params: data }));
    }
  },
  //人脸识别
  faceRecognizeNew: function (data) {
    // appNative.faceRecognizeNew(String data);
    window.appNative?.faceRecognizeNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'faceRecognizeNew', params: data }));
    }
  },
  //提现
  withdrawCashNew: function (data) {
    // appNative.withdrawCashNew(String data);
    window.appNative?.withdrawCashNew(data);
    if (this.flagKmr()) {
      window.postMessage(JSON.stringify({ command: 'withdrawCashNew', params: data }));
    }
  },
  //通用上传gps信息
  commonFingerPrintUpload: function (data) {
    // appNative.commonFingerPrintUpload(String data);
    window.appNative?.commonFingerPrintUpload(data);
  },
  //获取通讯录
  getContact: function (data) {
    window.appNative?.getContact(data);
    if (this.flagmsjr()) {
      window.postMessage(JSON.stringify({ command: 'selectContact', params: { index: data } }));
    }
  },
  //获取通讯录
  getAppChannel: function () {
    setTimeout(function () {
      window.appNative?.getAppChannel();
    }, 1500);

    if (this.flagmsjr()) {
      setTimeout(function () {
        window.postMessage(JSON.stringify({ id: '0', command: 'getAppChannel', params: {} }), '*');
      }, 1500);
    }
  },
  //跳到注册页面
  gotoRegister: function () {
    window.appNative?.gotoRegister();
  },
  getVtokenForH5: function () {
    window?.appNative?.getVtokenForH5();
    if (this.flagmsjr()) {
      window.postMessage(JSON.stringify({ id: '0', command: 'getVToken', params: {} }), '*');
    }
  },
  // 授权弹窗
  getPermForH5: function (time) {
    const { appKey } = useBaseStore();
    if (
      nativeCrawlerMethods.flag() ||
      nativeCrawlerMethods.flagyyh() ||
      nativeCrawlerMethods.flagmsfq()
    ) {
      window.appNative?.requestPermForH5?.();
    } else if (appKey === 'AYH_HMKP') {
      window.requestPermForH5 && window.requestPermForH5.call('');
    } else if (nativeCrawlerMethods.flagmsjr()) {
      if (window.dsBridge.hasNativeMethod('requestPermForH5')) {
        window.dsBridge.call('requestPermForH5');
      } else {
        setTimeout(function () {
          window.postMessage(
            JSON.stringify({ id: '0', command: 'requestPermForH5', params: {} }),
            '*',
          );
        }, time);
      }
    }
    localStorage.setItem('AuthPopUp_date1', Date.now() + '');
  },
};

export { nativeCrawlerMethods };
